<template>
  <MainLayout section="source">
    <b-container fluid id="source_container" :class="$mq">
      <b-row no-gutters id="source_header">
        <b-col>
          <a href="https://github.com/ripple/rippled">Rippled</a> Source Code Guide
        </b-col>
      </b-row>

      <b-row no-gutters id="source_subheader">
        <b-col>
          <div v-if="!has_section">
            The following is an independent source code analysis of <b>rippled v{{ version }}</b>
          </div>
        </b-col>
      </b-row>

      <b-row no-gutters v-if="!has_section" id="source_nav">
        <b-col>
          <ol id="source_sections">
            <li v-for="section in sections" :key="section.title">
              <router-link :to="{path : '/source/' + section.section}">
                <span v-html="section.title" />
              </router-link>
            </li>

            <li><b>More coming soon!</b></li>
          </ol>
        </b-col>
      </b-row>

      <b-row no-gutters v-if="has_section">
        <b-col>
          <h3><span v-html="title" /></h3>
        </b-col>
      </b-row>

      <SourceNav :section_index="section_index" v-if="has_section" />

      <b-row no-gutters v-if="has_section">
        <b-col>
          <div v-html="section" />
        </b-col>
      </b-row>

      <SourceNav :section_index="section_index" v-if="has_section" />
    </b-container>
  </MainLayout>
</template>

<script>
import MainLayout from './components/MainLayout.vue'
import SourceNav  from './components/SourceNav.vue'
import index      from './assets/source.json'

function _load_section(http, section, cb){
  http.get("/src/" + section + ".html").then(function(response){
    cb(response.body);
  });
}

const BASE_HLJS = 'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.15.10/';

/*global hljs*/
function load_hljs(){
  let _hljs = document.createElement('script')
  _hljs.type = "text/javascript";
  _hljs.setAttribute('src', BASE_HLJS + 'highlight.min.js');

  _hljs.onload = function(){
    hljs.initHighlightingOnLoad();

    let cmake = document.createElement('script')
    cmake.type = "text/javascript";
    cmake.setAttribute('src', BASE_HLJS + 'languages/cmake.min.js');
    document.head.appendChild(cmake)

    let cpp = document.createElement('script')
    cpp.type = "text/javascript";
    cpp.setAttribute('src', BASE_HLJS + 'languages/cpp.min.js');
    document.head.appendChild(cpp)

    let style = document.createElement('link')
    style.type = "text/css";
    style.rel = "stylesheet";
    style.setAttribute('href', BASE_HLJS + 'styles/default.min.css');
    document.head.appendChild(style)
  }

  document.head.appendChild(_hljs)
}

export default {
  name: 'Source',

  components: {
    MainLayout,
    SourceNav
  },

  props : {
    isection : String
  },

  data : function(){
    return {
      sections : index.sections,
      section  : null
    }
  },

  watch : {
    has_section : function(){
      if(this.has_section)
        this.load_section();
      else
        this.section = null;
    },

    isection : function(){
      if(this.has_section)
        this.load_section();
      else
        this.section = null;
    },

    section : function(){
      this.$nextTick().then(function(){
        document.querySelectorAll('pre code').forEach((block) => {
          hljs.highlightBlock(block);
        });

        window.scrollTo(0,0);
        // TODO: if url anchor is set, jump to that instead
      })
    }
  },

  computed : {
    version : function(){
      return index.version
    },

    commit : function(){
      return index.commit
    },

    url : function(){
      return index.url;
    },

    has_section : function(){
      return !!this.isection;
    },

    section_index : function(){
      return index.sections
                  .indexOf(index.sections
                                .find(function(s){
                                        return s.section == this.isection;
                                      }.bind(this)));
    },

    title : function(){
      return index.sections[this.section_index].title;
    },
  },

  methods : {
    source_url : function(target){
      return this.url + this.commit + "/" + target;
    },

    load_section : function(){
      _load_section(this.$http, this.$props.isection, function(data){
        this.section = data.replace(/RIPPLED_VERSION/g, this.version)
                           .replace(/RIPPLED_COMMIT/g,  this.commit)
                           .replace(/RIPPLED_URL\(([^)]*)\)/g, this.source_url("$1"));
      }.bind(this));
    }
  },

  mounted : function(){
    load_hljs();

    if(this.has_section)
      this.load_section();
  }
}
</script>

<style scoped>
#source_container{
  flex-grow: 1;
}

#source_header{
  margin-top: 25px;

  text-align: center;
  font-size: 1.7rem;
}

#source_subheader{
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid black;
}

#source_nav{
  border-bottom: 1px solid black;
}

#source_sections{
  margin-top: 10px;
}
</style>
